import { render, staticRenderFns } from "./EmoteWall.vue?vue&type=template&id=72ebbd53"
import script from "./EmoteWall.vue?vue&type=script&lang=js"
export * from "./EmoteWall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports